"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var classNames = require('classnames');

var TextLabel = require('../textLabel');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var skins = {
  standard: 'standard',
  premium: 'premium',
  attention: 'attention',
  success: 'success',
  alert: 'alert',
  urgent: 'urgent',
  general: 'general'
};
var defaultSkin = skins.standard;

var Badge = function Badge(_ref) {
  var automationId = _ref.automationId,
      value = _ref.value,
      dataHook = _ref.dataHook,
      disabled = _ref.disabled,
      getClassName = _ref.getClassName,
      skin = _ref.skin,
      uppercase = _ref.uppercase;

  var _skin = skins[skin] ? skins[skin] : defaultSkin;

  return /*#__PURE__*/React.createElement("span", {
    className: classNames(getClassName('control-badge'), "badge-".concat(_skin), {
      'to-uppercase': uppercase
    }),
    "data-aid": automationId,
    "data-hook": dataHook,
    disabled: disabled ? 'disabled' : ''
  }, /*#__PURE__*/React.createElement(TextLabel, {
    type: "T03",
    value: value
  }));
};

Badge.displayName = displayNames.BADGE;
Badge.propTypes = {
  /** content to be displayed */
  value: PropTypes.string,

  /** changing the look of the component */
  skin: PropTypes.oneOf(Object.values(skins)),

  /** forces uppercase letters */
  uppercase: PropTypes.bool
};
Badge.defaultProp = {
  uppercase: false
};
module.exports = compose(Badge);